import React, { useEffect } from "react";
import { Button, Space, Switch, Table, Tooltip } from "antd";
import { useModel } from "../../../models";
import AccountAdjustModel from "./AccountAdjustModel";
import AccountFillModel from "./AccountFillModel";
import AccountTransferModel from "./AccountTransferModel";

export default function () {
    const [
        { accountList, selectedCustomer, selectedAccountRowKeys, selectedAccount, tabsKey },
        {
            loadCustomerAccountList, setSelectedAccount, setSelectedAccountRowKeys,
            setAdjustModelVisible, setFillModelVisible, setTransferModelVisible,
            enableOrDisableAccount
        }
    ] = useModel("customer")
    const [{ accountTypeDict }, { getAccountTypeDict }] = useModel("cmDict");
    useEffect(() => {
        getAccountTypeDict()
        // console.log(accountTypeDict)
    }, [])
    useEffect(() => {
        console.log(selectedCustomer)
        loadCustomerAccountList({ showMsg: false, data: selectedCustomer.id })
    }, [selectedCustomer]);
    //调额
    const onAdjust = () => {
        setAdjustModelVisible(true);
    }
    //转账
    const onTransfer = () => {
        setTransferModelVisible(true);
    }
    //充值
    const onFill = () => {
        setFillModelVisible(true);
    }
    //启用、禁用
    const onDisabled = (record, checked) => {
        let { accountCode, id } = record
        let accountStatus = checked ? 0 : 1
        enableOrDisableAccount({ showMsg: true, data: { id, accountStatus } })
    }
    const columns = [
        {
            title: '账户编号',
            dataIndex: 'accountCode',
            // width: 80,
            // render: (text, record, index) => `${index + 1}`,
        },
        {
            title: '账户类型',
            dataIndex: 'accountType',
            render: (text, record) => {
                return (
                    <span>
                        {
                            accountTypeDict.map((item) => {
                                if (item.key == text) {
                                    return item.label
                                }
                            })
                        }
                    </span>
                )
            }
        },
        {
            title: '授信额度',
            dataIndex: 'creditLine',
        },
        {
            title: '已用授信额度',
            dataIndex: 'usedCreditLine',
        },
        {
            title: '可用额度',
            dataIndex: 'availableCredit',
        },
        {
            title: '剩余金额',
            dataIndex: 'remainingAmount',
        },
        {
            title: '抹零金额',
            dataIndex: 'omitAmount',
        },
        {
            title: '账户状态',
            key: 'accountStatus',
            render: (text, record) => (
                <Space size="middle" onClick={e => e.stopPropagation()}>
                    <Switch
                        checked={record.accountStatus == 0}
                        onChange={(checked) => {
                            onDisabled(record, checked);
                        }}
                        size="small" />
                </Space>
            ),
        },
        {
            title: '备注',
            dataIndex: 'remarks',
        },
    ];

    return (
        <>
            <div style={{ margin: "0 0 8px", }}>
                <Tooltip placement="topLeft" title="调整额度只能账户类型为授信用户，才可以调整额度">
                    <Button className="margin-left-8" onClick={onAdjust} disabled={selectedAccount && selectedAccount.accountType == "009001" ? false : true}>调额</Button>
                </Tooltip>
                <Button type="primary" className="margin-left-8" onClick={onFill}
                    disabled={!!!selectedAccount}>充值</Button>
                <Button type="primary" className="margin-left-8" onClick={onTransfer}>转账</Button>
            </div>

            <Table
                columns={columns}
                dataSource={accountList}
                bordered
                pagination={false}
                onRow={record => {
                    return {
                        onClick: event => {
                            if (selectedAccount && selectedAccount.key === record.key) {
                                setSelectedAccount(null);
                                setSelectedAccountRowKeys([]);
                            } else {
                                setSelectedAccount(record);
                                setSelectedAccountRowKeys([record.key]);
                            }
                        },
                    };
                }}
                rowSelection={{
                    type: "radio",
                    onChange: (selectedRowKeys, selectedRows) => {
                        console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
                        setSelectedAccount(selectedRows[0]);
                        setSelectedAccountRowKeys(selectedRowKeys);
                    },
                    getCheckboxProps: record => ({
                        disabled: record.name === 'Disabled',
                        name: record.name,
                    }),
                    selectedRowKeys: selectedAccountRowKeys
                }}
                scroll={{ x: 'max-content' }}
            />
            <AccountAdjustModel />
            <AccountFillModel />
            <AccountTransferModel />
        </>
    )
}